(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiEnter', taiEnter);

    function taiEnter() {
        return function(scope, element, attrs) {
            element.bind("keydown keypress", function(event) {
                if (event.which === 13) {
                    scope.$apply(function() {
                        scope.$eval(attrs.taiEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    }
})();